import { useLocation } from 'react-router-dom';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const location = useLocation();

  const getSchema = (): Record<string, unknown> => {
    const baseUrl = 'http://netkqn.com/';

    switch (type) {
      case 'Organization':
        return {
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '韩漫漫画',
          url: baseUrl,
          description: '韩漫漫画网站是免费韩漫与漫画大全的宝库，提供海量在线漫画资源，持续为您挖掘和推荐好看的韩国漫画。',
          sameAs: ['http://netkqn.com/'],
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            email: 'hello@netkqn.com',
            availableLanguage: ['Chinese'],
          },
        };
      case 'WebSite':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '韩漫漫画',
          url: baseUrl,
          description: '免费韩漫,漫画大全,在线漫画,好看的韩国漫画',
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${baseUrl}/search?q={search_term_string}`,
            },
            'query-input': 'required name=search_term_string',
          },
        };
      case 'WebPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          url: `${baseUrl}${location.pathname}`,
          name: data?.name || '韩漫漫画',
          description: data?.description || '韩漫漫画 - 免费在线韩国漫画阅读平台',
          inLanguage: 'zh-CN',
          isPartOf: {
            '@type': 'WebSite',
            name: '韩漫漫画',
            url: baseUrl,
          },
          ...(data?.breadcrumb && { breadcrumb: data.breadcrumb }),
        };
      case 'BreadcrumbList':
        return {
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: data?.items || [],
        };
      case 'Article':
        return {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: data?.headline || '',
          description: data?.description || '',
          author: {
            '@type': 'Person',
            name: data?.author || '韩漫漫画',
          },
          datePublished: data?.datePublished || '',
          dateModified: data?.dateModified || '',
          image: data?.image || '',
          url: `${baseUrl}${location.pathname}`,
          publisher: {
            '@type': 'Organization',
            name: '韩漫漫画',
          },
        };
      case 'FAQPage':
        return {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: data?.questions || [],
        };
      default:
        return {};
    }
  };

  const schema = { ...getSchema(), ...(data && {}) };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}